export default "__VITE_PUBLIC_ASSET__fc6f6118__"